export default "__VITE_ASSET__yktttvR1__"